import { observer } from "mobx-react";
import * as React from "react";
import { MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle } from "mdbreact";
import { CentralStore } from "../../stores/erros/CentralStore";
import { AppStore } from "../../stores/AppStore";
import history from "../others/redirect";
import { ADMIN_NAV_ITEMS, CALCULO_ITEMS_SUB, CALCULO_ITENS, CNPJS_ITEMS, INavItem, NAV_ITEMS, NAV_ITEMS4, NAV_LEGISLACAO_ARQUIVOS_PA, NAV_LEGISLACAO_RS, NAV_LEGISLACAO_TABELAS_PA, PRODUTOS_ITEMS_SUB, VARS_ITEMS_SUB, XMLS_ITEMS, XMLS_ITEMS_SUB } from "./NavItens";
import { observable } from "mobx";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { LegislacaoStore } from "../../stores/legislacao/LegislacaoStore";

require("../../assets/css/components/NavMenu.css");

@observer
export default class NavMenuAdmin extends React.Component<{}, {}> {

  obs = observable({
  })

  async componentDidMount() {

    await CentralStore.load();

  }

  closeDrowpDown() {
    document.getElementById("DrowpDownClose").style.visibility = "collapse";
  }
  openDrowpDown() {
    document.getElementById("DrowpDownClose").style.visibility = "";
  }
  closeDrowpDownAdmin() {
    document.getElementById("DrowpDownCloseAdmin").style.visibility = "collapse";
  }
  openDrowpDownAdmin() {
    document.getElementById("DrowpDownCloseAdmin").style.visibility = "";
  }
  closeDrowpDownDecla() {
    document.getElementById("DrowpDownCloseDecla").style.visibility = "collapse";
  }
  openDrowpDownDecla() {
    document.getElementById("DrowpDownCloseDecla").style.visibility = "";
  }
  closeDrowpDownLegis() {
    document.getElementById("DrowpDownCloseLegis").style.visibility = "collapse";
  }
  openDrowpDownLegis() {
    document.getElementById("DrowpDownCloseLegis").style.visibility = "";
  }

  async onPush(path) {

    EmpresaStore.obs.certificado = "";
    EmpresaStore.obs.status = "";

    if (path == "/calculo-icms") {

      await LegislacaoStore.get_pdf("icms")
      return

    }

    if (path == "/decreto-icms") {

      await LegislacaoStore.get_pdf("decreto")
      return

    }

    history.push(path)

  }

  renderItem = (item: INavItem, admin: boolean) => {
    let className = "nz-nav-menu-item";
    let classNameSpan = "badge-emp pulse hidden-span";

    if (AppStore.obs1.location.area == item.area) {
      className += " mod-selected";
    }
    if (admin) className += " mod-admin";

    let path = `/${item.area}`;
    if (item.action) path += `/${item.action}`;

    return (
      <li key={item.key} className="nav-item" onClick={() => this.onPush(path)}>
        <a className={className}>
          <span className="icon-nav-menu">
            {AppStore.obs1.location.area == item.area
              ? item.iconActive
              : item.icon}
          </span>
          {item.key == "sped" || item.key == "relatorios" || item.key == "downloads-xml" || item.key == "sitfis" || item.key == "dei" ?
            <div className="nz-nav-menu-item-text">{item.text} <span className="new-tag-nav-new">Novo</span></div>
            :
            <>
              {item.key == "pgdas" || item.key == "xml-integration" || item.key == "fgts-digital" || item.key == "nfse-prefeitura"|| item.key == "portal-nfe" ?
                <div className="nz-nav-menu-item-text">{item.text} <span className="new-tag-nav-new">Beta</span></div>
                :
                <div className="nz-nav-menu-item-text">{item.text}</div>
              }
            </>
          }
          <span className={classNameSpan}></span>
        </a>
      </li>
    );
  };

  renderDashboard() {

    return NAV_ITEMS?.map(item => this.renderItem(item, false));

  }

  renderEmpresas() {

    return CNPJS_ITEMS?.map(item => this.renderItem(item, false));
  }

  renderDeclaracoes() {

    return (<>

      <li className="itensAdmin">
        <MDBDropdown className="dropdownAdmin dropdownMenu">
          <MDBDropdownToggle onClick={() => this.openDrowpDownDecla()} caret color="default">
            <img src="/images/money.png" width="27px;" /> Declarações
          </MDBDropdownToggle>
          <div id="DrowpDownCloseDecla">
            <MDBDropdownMenu basic>

              <MDBDropdownItem>
                {NAV_ITEMS4?.map(item => this.renderItem(item, true))}
              </MDBDropdownItem>

            </MDBDropdownMenu>
          </div>
        </MDBDropdown>
      </li>

    </>)

  }

  renderXmls() {

    return (<>

      <li className="itensAdmin">
        <MDBDropdown className="dropdownAdmin dropdownMenu">
          <MDBDropdownToggle onClick={() => this.openDrowpDown()} caret color="default">
            <img src="/images/xml.svg" width="27px;" /> XMLs
          </MDBDropdownToggle >
          <div id="DrowpDownClose">
            <MDBDropdownMenu basic>
              <MDBDropdownItem>
                {XMLS_ITEMS?.map(item => this.renderItem(item, true))}
              </MDBDropdownItem>
              <MDBDropdown dropright className="dropdownAdmin dropdownMenu dropdownMenusoli">
                <MDBDropdownToggle className="buttonSubmenu" caret color="default">
                  {"Solicitações de Arquivos"}&nbsp;&nbsp;
                </MDBDropdownToggle>
                <MDBDropdownMenu basic>
                  <p className="arquivos-divider">Pará: </p>
                  <div className="dropdown-divider" />
                  <MDBDropdownItem onClick={() => this.closeDrowpDown()}>
                    {XMLS_ITEMS_SUB?.map(item => this.renderItem(item, true))}
                  </MDBDropdownItem>
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBDropdownMenu>
          </div>
        </MDBDropdown>
      </li>

    </>)

  }

  renderCalculos() {

    return (<>

      <li className="itensAdmin">
        <MDBDropdown className="dropdownAdmin dropdownMenu">
          <MDBDropdownToggle caret color="default">
            <img src="/images/calculos.svg" width="27px;" />{" "}
            Cálculos
          </MDBDropdownToggle>
          <MDBDropdownMenu basic>
            <MDBDropdownItem>
              {CALCULO_ITENS?.map(item => this.renderItem(item, true))}
            </MDBDropdownItem>
          </MDBDropdownMenu>
        </MDBDropdown>
      </li>

    </>)

  }

  renderLegislacao() {

    return (<>

      <li className="itensAdmin">
        <MDBDropdown className="dropdownAdmin dropdownMenu">
          <MDBDropdownToggle onClick={() => this.openDrowpDownLegis()} caret color="default">
            <img src="/images/legislacao.png" width="27px;" /> Legislação
          </MDBDropdownToggle >
          <div id="DrowpDownCloseLegis">
            <MDBDropdownMenu basic>

              <MDBDropdown dropright className="dropdownAdmin dropdownMenu dropdownMenuLegislacao">
                <MDBDropdownToggle className="buttonSubmenu" caret color="default">
                  {"Pará"}&nbsp;&nbsp;
                </MDBDropdownToggle>
                <MDBDropdownMenu basic>
                  <MDBDropdown dropright className="dropdownAdmin dropdownMenu dropdownMenuLegislacaoSub1">
                    <MDBDropdownToggle className="buttonSubmenu" caret color="default">
                      {"Arquivos"}&nbsp;&nbsp;
                    </MDBDropdownToggle>
                    <MDBDropdownMenu basic>
                      <MDBDropdownItem onClick={() => this.closeDrowpDownLegis()}>
                        {NAV_LEGISLACAO_ARQUIVOS_PA?.map(item => this.renderItem(item, true))}
                      </MDBDropdownItem>
                    </MDBDropdownMenu>
                  </MDBDropdown>

                  <MDBDropdown dropright className="dropdownAdmin dropdownMenu dropdownMenuLegislacaoSub2">
                    <MDBDropdownToggle className="buttonSubmenu" caret color="default">
                      {"Tabelas"}&nbsp;&nbsp;
                    </MDBDropdownToggle>
                    <MDBDropdownMenu basic>
                      <MDBDropdownItem onClick={() => this.closeDrowpDownLegis()}>
                        {NAV_LEGISLACAO_TABELAS_PA?.map(item => this.renderItem(item, true))}
                      </MDBDropdownItem>
                    </MDBDropdownMenu>
                  </MDBDropdown>
                </MDBDropdownMenu>
              </MDBDropdown>

              <MDBDropdown dropright className="dropdownAdmin dropdownMenu">
                <MDBDropdownToggle className="buttonSubmenu" caret color="default">
                  {"Rio Grande do Sul"}&nbsp;&nbsp;
                </MDBDropdownToggle>
                <MDBDropdownMenu basic>
                  <MDBDropdownItem onClick={() => this.closeDrowpDownLegis()}>
                    {NAV_LEGISLACAO_RS?.map(item => this.renderItem(item, true))}
                  </MDBDropdownItem>
                </MDBDropdownMenu>
              </MDBDropdown>

            </MDBDropdownMenu>
          </div>
        </MDBDropdown>
      </li>

    </>)

  }

  renderAdmin() {

    return (<>

      <li className="itensAdmin">
        <MDBDropdown className="dropdownAdmin dropdownMenu">
          <MDBDropdownToggle onClick={() => this.openDrowpDownAdmin()} caret color="default">
            <img src="/images/admin.svg" width="30px;" /> Admin
          </MDBDropdownToggle>
          <div id="DrowpDownCloseAdmin">
            <MDBDropdownMenu basic>
              <MDBDropdownItem>
                {ADMIN_NAV_ITEMS?.map(item => this.renderItem(item, true))}
              </MDBDropdownItem>
              <MDBDropdown dropright className="dropdownAdmin dropdownMenu dropdownMenuCalcs">
                <MDBDropdownToggle className="buttonSubmenu" caret color="default">
                  Formas de cálculos &nbsp;&nbsp;
                </MDBDropdownToggle>
                <MDBDropdownMenu basic>
                  <MDBDropdownItem onClick={() => this.closeDrowpDownAdmin()}>
                    {CALCULO_ITEMS_SUB?.map(item => this.renderItem(item, true))}
                  </MDBDropdownItem>
                </MDBDropdownMenu>
              </MDBDropdown>

              <MDBDropdown dropright className="dropdownAdmin dropdownMenu dropdownMenuVars">
                <MDBDropdownToggle className="buttonSubmenu" caret color="default">
                  Produtos &nbsp;&nbsp;
                </MDBDropdownToggle>
                <MDBDropdownMenu basic>
                  <MDBDropdownItem onClick={() => this.closeDrowpDownAdmin()}>
                    {PRODUTOS_ITEMS_SUB?.map(item => this.renderItem(item, true))}
                  </MDBDropdownItem>
                </MDBDropdownMenu>
              </MDBDropdown>

              <MDBDropdown dropright className="dropdownAdmin dropdownMenu dropdownMenuVars">
                <MDBDropdownToggle className="buttonSubmenu" caret color="default">
                  Variáveis &nbsp;&nbsp;
                </MDBDropdownToggle>
                <MDBDropdownMenu basic>
                  <MDBDropdownItem onClick={() => this.closeDrowpDownAdmin()}>
                    {VARS_ITEMS_SUB?.map(item => this.renderItem(item, true))}
                  </MDBDropdownItem>
                </MDBDropdownMenu>
              </MDBDropdown>

            </MDBDropdownMenu>
          </div>
        </MDBDropdown>
      </li>

    </>)
  }

  render() {

    return (

      <>

        <ul className="ul-menu">
          {this.renderDashboard()}
          {this.renderEmpresas()}
          {this.renderDeclaracoes()}
          {this.renderXmls()}
          {this.renderCalculos()}
          {this.renderLegislacao()}
          {this.renderAdmin()}
        </ul>

      </>

    );

  }

}
